var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrowActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Interactive-States",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05_MSO-Company-Charting-Interactive-State---Overlays-2",
    transform: "translate(-1352.000000, -1303.000000)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(22.000000, 1292.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(1291.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6902087,11.7182515 L42.4088102,16.999 L54.1999879,17 C54.6102628,17 54.948405,17.3860402 54.9946177,17.8833789 L55,18 C55,18.5128358 54.6911632,18.9355072 54.2932862,18.9932723 L54.1999879,19 L42.4078102,18.999 L47.6902087,24.2817485 C48.6292697,25.2207954 47.2206782,26.6293657 46.2816171,25.6903189 L39.5329029,18.9430109 C39.2533453,18.8193974 39.0451447,18.5070538 39.0063001,18.1284772 L39.0002655,17.9926635 L39.0002655,17.9926635 C38.9994074,17.9577746 39.0006524,17.9258446 39.0036677,17.8938071 C39.0372172,17.5049469 39.2480056,17.1829637 39.5329029,17.0569891 L46.2816171,10.3096811 C47.2206782,9.37063426 48.6292697,10.7792046 47.6902087,11.7182515 Z",
    id: "Path",
    transform: "translate(47.000000, 18.000000) rotate(-270.000000) translate(-47.000000, -18.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowActive);
export default __webpack_public_path__ + "static/media/UpArrowActive.86ddea2346fb12490d441909ca46abb6.svg";
export { ForwardRef as ReactComponent };